const user = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email address",
  gender: "Gender",
  phone_number: "Mobile number",
  birthday_with_format: "Date of birth mm/dd/yyyy",
  gender_options: {
    male: "Male",
    female: "Female",
    unspecified: "Unspecified",
  },
  culture_id: "Select your family’s country of origin",
  other_culture_name: "Please specify your family’s country of origin",
  mexico_state_id: "Which Mexico state does your family come from?",
  interests: "Interests",
  language: "Language",
  language_options: {
    spanish: "Spanish",
    english: "English",
  },
  profile: {
    account_info: "Account information",
    add_card: "Add card",
    add_new_card: "Add new card",
    annual_interval: "year",
    annual_plan: "PODERsalud annual",
    cancel_edit_cta: "Cancel",
    card_info: "Card information",
    default: "Default",
    expires_on: "Expires on",
    make_default: "Make this my default payment method",
    monthly_interval: "month",
    monthly_plan: "PODERsalud monthly",
    next_billing: "Next billing date",
    payment_cta_title: "Payment Info",
    payment_methods: "Payment Methods",
    plan: "Plan",
    price: "Price",
    submit_cta: "Submit Changes",
  },
};

export default user;
